import React, { useState } from "react";
import Banner from "./Banner/Banner";
import StatusOFCards from "./StatusOFCards/StatusOFCards";
import Completed from "./Completed/Completed";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import Footer from "../../GlobalComponents/Footer/Footer";
import { privateNav } from "../../utils/navItems";

const Raise = () => {
  return (
    <div>
      <NavLayout
        navItems={privateNav}
        buttons={
          <div className="button-container xl:gap-[49px]">
            <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
              <span>R34P</span>
              <span className="font-black"> $36.65</span>
            </button>
            <button className="nav-button-rounded w-[128px]">Connect</button>
          </div>
        }
      ></NavLayout>

      <Banner></Banner>
      <StatusOFCards></StatusOFCards>
      <Completed></Completed>
      <div className="mt-10 ">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Raise;
